<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import service from '../../../../domain/grv/services'
  import {isArray, debounce} from 'lodash'
  import moment from 'moment'
  import BtnCheckPossui from './CheckPossui'
  import Vue from 'vue'
  import PatenteService from '../../../../domain/policia-civil/patentes/services/patentes'
  import UnidadePolicialService from '../../../../domain/policia-civil/unidade-policial/services/unidade-policial'
  import SeguradoraService from '../../../../domain/policia-civil/seguradora/services/seguradora'
  import PolicialService from '../../../../domain/policia-civil/policial/services/policial'
  import AtendentePatioService from '../../../../domain/policia-civil/atendente-patio/services/atendente-patio'
  import TiposGrvService from '../../../../domain/policia-civil/tipo-grv/services/tipo-grv'
  import ReintegradoraService from '../../../../domain/policia-civil/reintegrador/services/reintegrador'
  import RepresentanteService from '../../../../domain/policia-civil/reintegrador/services/representante'
  import LocadoraService from '../../../../domain/policia-civil/locadora/services/locadora'
  import TiposDevolucaoService from '../../../../domain/policia-civil/tipo-devolucao/services/tipo-devolucao'
  import SituacaoApreensaoService from '../../../../domain/policia-civil/situacao-apreensao/services/situacao-apreensao'
  import EstadoVeiculoService from '../../../../domain/policia-civil/estado-veiculo/services/estado-veiculo'
  import AvariaService from '../../../../domain/policia-civil/avaria/services/avaria'
  import {findGev, cadastrarGev} from '../../../../domain/policia-civil/gev/services/gev'

  const POSSUI = '1'
  const NAO_POSSUI = '2'
  const NAO_MARCA = '5'

  let templateLacre = {id: null, numero: null, violado: false}
  let templateArquivo = {id: null, nomeArquivo: null, nomeOriginal: null, descricao: null, tipo: null, arquivo: null}
  let templateEquipamento = {id: null, possui: true, equipamento: {id: null, nome: null}}

  export default {
    components: {
      BtnCheckPossui
    },
    nome: 'gev',
    props: {
      grv: {
        type: Object,
        required: true
      },
      gevId: {
        type: Number,
        required: false
      }
    },
    directives: {mask},
    data () {
      return {
        baseFotoUrl: `${process.env.API_URL}/api/public/grv-foto`,
        isGgv: false,
        dataRequired: {
          equipamentos: []
        },
        dataRequiredLoaded: false,
        extraModel: {
          dataApreensao: null,
          horaApreensao: null,
          dataRemocao: null,
          horaRemocao: null
        },
        data: {
          id: null,
          numero: null,
          representanteReintegradora: null,
          ano: null,
          bairroApreensao: null,
          chassi: null,
          numeroMotor: null,
          chavesVeiculo: 1,
          numeroChave: null,
          cidadeApreensao: null,
          cidadeCondutor: null,
          // codigoInfracao: null,
          equipamentos: [],
          // motivoInfracaoOutros: null,
          marca: null,
          modelo: null,
          cor: null,
          vaga: null,
          cpfCondutor: null,
          data: null,
          dataApreensao: null,
          enderecoApreensao: null,
          enderecoCondutor: null,
          estadoCondutor: null,
          lacres: [
            JSON.parse(JSON.stringify(templateLacre)),
            JSON.parse(JSON.stringify(templateLacre)),
            JSON.parse(JSON.stringify(templateLacre))
          ],
          matriculaAgenteApreensor: null,
          nivelCombustivel: null,
          nomeAgenteApreensor: null,
          nomeCondutor: null,
          // numeroAutoInfracao: null,
          observacoes: null,
          orgaoEmissorRgCondutor: null,
          placa: null,
          renavam: null,
          rgCondutor: null,
          telefoneCondutor: null,
          // tipoOperacao: 2,
          tipoRemocao: 2,
          volumesInteriorVeiculo: null,
          comRubrica: null,
          rubrica: null,
          comAssinaturaCondutor: null,
          assinaturaCondutor: null,
          comAssinaturaTestemunha: null,
          condutorPresente: null,
          ufApreensao: null,
          orgaoApreensor: null,
          reboque: null,
          reboquista: null,
          contrato: null,
          bemCategoria: null,
          patio: null,
          kmForaDaCidade: null,
          kmInicialDoReboque: 0,
          complementoApreensao: null,
          complementoCondutor: null,
          codigoGrv: null,
          liberarPorDecisaoJudicial: false,
          liberarPorPrensa: false,
          liberarPorRouboFurto: false,
          arquivos: [
            JSON.parse(JSON.stringify(templateArquivo))
          ],
          /* grv roubo furto */
          // statusProcesso: null,
          dpOrigem: null,
          roOrigem: null,
          dataRoOrigem: null,
          roApreensaoRecuperacao: null,
          naoEmplacado: false,
          possuiPlacaOriginal: false,
          semPlaca: false,
          comRodas: false,
          delito: null,
          localizacaoAtual: null,
          veiculoNaoIdentificado: false,
          periciaRealizada: false,
          formularioOperadora: null,
          formularioPatio: null,
          recebedorPatio: null,
          recebedorCpf: null,
          recebedorRg: null,
          trancado: false,
          indenizado: false,
          veiculoSegurado: false,
          seguradora: null,
          apoliceSinistro: null,
          tipoGev: null,
          observacoesGev: null,
          dataEntregaDevolucao: null,
          tipoDevolucao: null,
          nomeDevolucao: null,
          cpfDevolucao: null,
          telefoneDevolucao1: null,
          telefoneDevolucao2: null,
          telefoneDevolucao3: null,
          telefoneDevolucao4: null,
          entregadorPatio: null,
          policialRecebedorPatio: null,
          unidadePolicialRecebedorPatio: null,
          dataContatoReintegracao: null,
          transferirProcesso: false,
          patioTransferencia: null,
          empresaContratante: null,
          reintegradora: null,
          observacoesReintegracao: null,
          policialApreensao: null,
          seguradoraAssociados: null,
          locadora: null,
          placaOriginal: null,
          situacaoApreensao: null,
          dataSolicitacaoReboque: null,
          dataPrevisaoChegada: null,
          dataChegadaRemocao: null,
          dataSaidaRemocao: null,
          dataEntradaPatio: null,
          dataSaidaPatio: null,
          // kmForaDaCidadeReboquePatio: null,
          // kmInicialDoReboquePatio: 0,
          enderecoRemocao: null,
          bairroRemocao: null,
          ufRemocao: null,
          complementoRemocao: null,
          cidadeRemocao: null,
          kmFinalDoReboque: 0,
          unidadePolicialApreensao: null,
          patentePolicialApreensao: null,
          observacoesReboque: null,
          observacoesEquipamentos: null,
          comAssinaturaPolicial: false,
          comAssinaturaReboquista: false,
          placaAlterada: null,
          dataPlacaAlterada: null,
          tipoGgv: null,
          estadoVeiculo: null,
          observacoesGgv: null,
          comChave: null
        },
        ggv: {
          conforme: false
        },
        edit: false,
        isLoading: false,
        cadastroError: null,
        atualizadoSucesso: null,
        statusOptions: [
          {label: 'Ativo', value: 1, class: 'btn-default'},
          {label: 'Inativo', value: 0, class: 'btn-default'},
          {label: 'Cancelado', value: -1, class: 'btn-default'}
        ],
        showFormPolicial: false,
        policialSelecionado: {
          nome: null,
          matricula: null
        },
        patentes: [],
        unidadesPoliciais: [],
        seguradoras: [],
        policiais: [],
        entregadoresPatio: [],
        tiposGrv: [],
        reintegradoras: [],
        representantes: [],
        locadoras: [],
        tiposDevolucao: [],
        situacoesApreensao: [],
        avarias: [],
        estadosVeiculo: [],
        filtro: '',
        showOptionsAutocomplete: false,
        loading: false,
        isPreenchidoAutomaticamente: false
      }
    },
    computed: {},
    created () {
      this.carregarEntregadoresPatio()
      this.carregarAvarias()
      this.carregarPatentes()
      this.carregarUnidadesPoliciais()
      this.carregarSeguradoras()
      this.carregarAtendentesPatio()
      this.carregarTiposGrv()
      this.carregarReintegradoras()
      this.carregarLocadoras()
      this.carregarTiposDevolucao()
      this.carregarSituacoesApreensao()
      this.carregarEstadosVeiculo()
    },
    mounted () {
      this.$loaderOverlay.open().message('Carregando dados relacionados')
      service.dataRequired()
        .then((response) => {
          this.$loaderOverlay.hide()
          this.dataRequiredLoaded = true
          this.dataRequired = response.data
          if (isArray(this.dataRequired.equipamentos) && this.dataRequired.equipamentos.length > 0) {
            this.dataRequired.equipamentos = this.dataRequired.equipamentos.filter(equipamento => equipamento.policiaCivil)
            for (let i = 0; i < this.dataRequired.equipamentos.length; i++) {
              // this.$set(this.dataRequired.equipamentos[i], 'checked', false)
              // this.$set(this.dataRequired.equipamentos[i], 'possui', false)
              Vue.util.defineReactive(this.dataRequired.equipamentos[i], 'checked', false)
              Vue.util.defineReactive(this.dataRequired.equipamentos[i], 'possui', NAO_MARCA)
            }
          }
          // this.data.numero = this.dataRequired.sequencialGrv
          this.start()
          console.log(response)
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    activated () {
    },
    destroyed () {
    },
    methods: {
      start () {
        if (this.gevId && this.gevId !== 'registrar') {
          this.edit = true
          this.$loaderOverlay.open().message('Carregando GEV')
          if (typeof this.$route.query.ggv !== 'undefined') {
            this.isGgv = true
          }
          findGev(this.gevId)
            .then((response) => {
              this.$loaderOverlay.hide()
              let data = response.data

              const formataData = date => date ? moment(date.date).format('L LT') : null

              data.policialApreensao = data.policialApreensao ? data.policialApreensao.id : null
              data.policialRecebedorPatio = data.policialRecebedorPatio ? data.policialRecebedorPatio.id : null
              data.dataRoOrigem = formataData(data.dataRoOrigem)
              data.dataEntregaDevolucao = formataData(data.dataEntregaDevolucao)
              data.dataContatoReintegracao = formataData(data.dataContatoReintegracao)
              data.dataSolicitacaoReboque = formataData(data.dataSolicitacaoReboque)
              data.dataPrevisaoChegada = formataData(data.dataPrevisaoChegada)
              data.dataChegadaRemocao = formataData(data.dataChegadaRemocao)
              data.dataSaidaRemocao = formataData(data.dataSaidaRemocao)
              data.dataEntradaPatio = formataData(data.dataEntradaPatio)
              data.dataSaidaPatio = formataData(data.dataSaidaPatio)
              data.dataPlacaAlterada = formataData(data.dataPlacaAlterada)
              data.seguradoraAssociados = data.seguradoraAssociados ? data.seguradoraAssociados.id : null
              data.locadora = data.locadora ? data.locadora.id : null
              data.unidadePolicialRecebedorPatio = data.unidadePolicialRecebedorPatio ? data.unidadePolicialRecebedorPatio.id : null
              data.seguradora = data.seguradora ? data.seguradora.id : null
              data.tipo = (data.grv ? data.grv.tipoGev : null) ? data.grv.tipoGev.id : null
              data.tipoDevolucao = data.tipoDevolucao ? data.tipoDevolucao.id : null
              data.entregadorPatio = data.entregadorPatio ? data.entregadorPatio.id : null
              data.patioTransferencia = data.patioTransferencia ? data.patioTransferencia.id : null
              data.reintegradora = data.reintegradora ? data.reintegradora.id : null
              data.situacaoApreensao = data.situacaoApreensao ? data.situacaoApreensao.id : null
              data.estadoVeiculo = data.estadoVeiculo ? data.estadoVeiculo.id : null
              data.recebedorPatio = data.recebedorPatio ? data.recebedorPatio.id : null
              data.representanteReintegradora = data.representanteReintegradora ? data.representanteReintegradora.id : null

              if (data.representanteReintegradora) this.carregarRepresentantes()
              data.equipamentos = data.grv.equipamentos

              /* if (isArray(data.equipamentos) && data.equipamentos.length > 0) {
                this.dataRequired.equipamentos.forEach((e) => {
                  let find = data.equipamentos.findIndex((e1) => e1.equipamento.id === e.id)
                  if (typeof find !== 'undefined' && find !== -1) {
                    e.checked = true
                    e.possui = data.equipamentos[find].equipamento.possui
                  }
                })
              } */
              if (isArray(data.equipamentos) && data.equipamentos.length > 0) {
                data.equipamentos = data.equipamentos.map(item => {
                  item.equipamento.possui = item.possui
                  if (item.avaria) {
                    item.equipamento.avaria = item.avaria.id
                  }
                  return item.equipamento
                })
                this.dataRequired.equipamentos.forEach((e) => {
                  let find = data.equipamentos.findIndex((e1) => e1.id === e.id)
                  if (typeof find !== 'undefined' && find !== -1) {
                    e.checked = true
                    e.possui = data.equipamentos[find].possui
                    e.avaria = data.equipamentos[find].avaria
                    data.equipamentos[find] = e
                  }
                })
              }
              data.grv = data.grv ? data.grv.id : this.grv.id
              this.data = data
              console.log(response)
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
          this.data.grv = this.data.grv ? this.data.grv.id : this.grv.id
          const {atendimentos} = this.grv

          if (atendimentos.length) {
            const atendimento = atendimentos[atendimentos.length - 1]
            this.isPreenchidoAutomaticamente = true

            this.data.nomeDevolucao = atendimento.nome
            this.data.telefoneDevolucao1 = atendimento.telefone1
            this.data.telefoneDevolucao2 = atendimento.telefone2
            this.data.telefoneDevolucao3 = atendimento.telefone3
            this.data.cpfDevolucao = atendimento.cpf
            this.data.veiculoSegurado = atendimento.veiculoSegurado
            this.data.seguradora = atendimento.seguradora && atendimento.seguradora.id
            this.data.apoliceSinistro = atendimento.apoliceSinistro
            this.data.equipamentos = JSON.parse(JSON.stringify(this.grv.equipamentos))

            if (isArray(this.data.equipamentos) && this.data.equipamentos.length > 0) {
              this.data.equipamentos = this.data.equipamentos.map(item => {
                item.equipamento.possui = item.possui
                if (item.avaria) {
                  item.equipamento.avaria = item.avaria.id
                }
                return item.equipamento
              })
              this.dataRequired.equipamentos.forEach((e) => {
                let find = this.data.equipamentos.findIndex((e1) => e1.id === e.id)
                if (typeof find !== 'undefined' && find !== -1) {
                  e.checked = true
                  e.possui = this.data.equipamentos[find].possui
                  e.avaria = this.data.equipamentos[find].avaria
                  this.data.equipamentos[find] = e
                }
              })
            }
          }
        }
      },
      submit () {
        let confirm = window.confirm('Tem certeza que deseja gerar a GEV?')
        if (!confirm) return

        this.cadastroError = null
        this.$loaderOverlay.open().message('Processando')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde, registrando GEV...')
        }, 1000)
        let data = JSON.parse(JSON.stringify(this.data))
        // data.data = this.extraModel.dataRemocao + ' ' + this.extraModel.horaRemocao
        // data.dataApreensao = this.extraModel.dataApreensao + ' ' + this.extraModel.horaApreensao
        if (this.isGgv) {
          data.isGgv = true
          data.ggv = this.ggv
        }
        data.equipamentos = data.equipamentos.map(equip => {
          equip.possui = equip.possui ? POSSUI : NAO_POSSUI
          return equip
        })
        /* if (this.policialSelecionado) {
          data.policialRecebedorPatio = this.policialSelecionado.id
        } */
        cadastrarGev(data, this.gevId).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            this.$emit('finishSubmit', response.data.id)
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      },
      adicionarLacre () {
        this.data.lacres.push(JSON.parse(JSON.stringify(templateLacre)))
      },
      adicionarArquivo () {
        this.data.arquivos.push(JSON.parse(JSON.stringify(templateArquivo)))
      },
      uploadDocumento (e) {
        const reader = new FileReader()
        const file = e.target.files[0]
        const _this = this
        reader.onloadend = function () {
          const lastPosition = _this.data.arquivos.length - 1
          _this.data.arquivos[lastPosition].arquivo = reader.result
          _this.$el.querySelector(e.target.id).value = ''
        }

        if (file) {
          reader.readAsDataURL(file)
        } else {
          alert('erro na leitura do arquivo')
        }
      },
      marcaEquipamento (e, v) {
        let template = JSON.parse(JSON.stringify(templateEquipamento))
        // this.$set(this.dataRequired.equipamentos[this.dataRequired.equipamentos.indexOf(v)], 'checked', e.target.checked)
        v.checked = e.target.checked
        if (e.target.checked) {
          // template.possui = v.possui
          template = v
          this.$set(template, 'possui', v.possui)
          /* Object.defineProperty(template, 'possui', {
            get () {
              return template.possui
            }
          }) */
          // delete template.equipamento.possui
          this.data.equipamentos.push(template)
        } else {
          this.data.equipamentos = this.data.equipamentos.filter((e) => {
            // return e.equipamento.id !== v.id
            return e.id !== v.id
          })
        }
        console.log(this.data.equipamentos)
      },
      consultaPlacaChassi () {
        this.$loaderOverlay.open().message('Carregando dados do veículo')
        service.consultaPlacaChassi(this.data)
          .then((response) => {
            console.log(response)
            this.$loaderOverlay.hide()
            // result = JSON.parse(response.data)
            let data = JSON.parse(response.data)
            if (data.Retorno === 'OK') {
              this.data.placa = data.Placa
              this.data.chassi = data.Chassi
              this.data.marca = data.DescricaoMarca
              this.data.modelo = data.DescricaoTipo
              this.data.cor = data.DescricaoCor
              this.data.renavam = data.NumeroRenavam
              this.data.ano = data.AnoFabricacao

              if (data.Classificacao === 'LA') {
                this.data.bemCategoria = 1
              } else if (data.Classificacao === 'LB') {
                this.data.bemCategoria = 2
              } else if (data.Classificacao === 'LC') {
                this.data.bemCategoria = 3
              } else if (data.Classificacao === 'PD') {
                this.data.bemCategoria = 4
              }
            } else {
              alert(data.Retorno)
            }
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            alert(response.Retorno)
          })
      },
      openFormPolicial () {
        this.showFormPolicial = true
      },
      closeFormPolicial () {
        this.carregarPoliciais()
        this.showFormPolicial = false
      },
      setPolicialSelecionado (evt, id = null) {
        if (id === null) return
        const found = this.policiais.find(policial => policial.id === id)
        this.policialSelecionado = found ? JSON.parse(JSON.stringify(found)) : null
      },
      carregarPatentes () {
        PatenteService.list(10000, 1, '')
          .then(response => {
            this.patentes = response.data.arrayData
          })
          .catch(error => {
            alert('Erro ao carregar as patentes')
            console.log(error)
          })
      },
      carregarUnidadesPoliciais () {
        UnidadePolicialService.list(10000, 1, '')
          .then(response => {
            this.unidadesPoliciais = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar as unidades policiais')
            console.log(error)
          })
      },
      carregarSeguradoras () {
        SeguradoraService.list(10000, 1, '')
          .then(response => {
            this.seguradoras = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar as unidades policiais')
            console.log(error)
          })
      },
      carregarPoliciais (filtro = null, unique = false) {
        if (unique) {
          PolicialService.find(filtro)
            .then(response => {
              this.policialSelecionado = response.data
            })
            .catch(error => {
              alert('Erro ao carregar policial')
              console.log(error)
            })
        } else {
          PolicialService.list(10000, 1, `&busca=${filtro}`)
            .then(response => {
              this.policiais = response.data.result
              this.loading = false
            })
            .catch(error => {
              alert('Erro ao carregar lista de policiais')
              console.log(error)
            })
        }
      },
      carregarAtendentesPatio () {
        AtendentePatioService.list(10000, 1, '')
          .then(response => {
            this.atendentesPatio = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar lista de atendentes de pátio')
            console.log(error)
          })
      },
      carregarTiposGrv () {
        TiposGrvService.list(10000, 1, '')
          .then(response => {
            this.tiposGrv = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar lista de tipos de grv')
            console.log(error)
          })
      },
      carregarReintegradoras () {
        ReintegradoraService.list(10000, 1, '')
          .then(response => {
            this.reintegradoras = response.data.result
            this.carregarRepresentantes()
          })
          .catch(error => {
            alert('Erro ao carregar lista de reintegradoras')
            console.log(error)
          })
      },
      carregarRepresentantes: debounce(function () {
        RepresentanteService.listByReintegradora(this.data.reintegradora)
          .then(response => {
            this.representantes = response.data
          })
          .catch(error => {
            alert('Erro ao carregar lista de reintegradoras')
            console.log(error)
          })
      }, 100),
      carregarLocadoras () {
        LocadoraService.list(10000, 1, '')
          .then(response => {
            this.locadoras = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar lista de locadoras')
            console.log(error)
          })
      },
      carregarTiposDevolucao () {
        TiposDevolucaoService.list(10000, 1, '')
          .then(response => {
            this.tiposDevolucao = response.data.arrayData
          })
          .catch(error => {
            alert('Erro ao carregar lista de tipos de devolução')
            console.log(error)
          })
      },
      carregarSituacoesApreensao () {
        SituacaoApreensaoService.list(10000, 1, '')
          .then(response => {
            this.situacoesApreensao = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar lista de situações de apreensão')
            console.log(error)
          })
      },
      carregarAvarias () {
        AvariaService.list(10000, 1, '')
          .then(response => {
            this.avarias = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar lista de avarias')
            console.log(error)
          })
      },
      carregarEstadosVeiculo () {
        EstadoVeiculoService.list(10000, 1, '')
          .then(response => {
            this.estadosVeiculo = response.data.arrayData
          })
          .catch(error => {
            alert('Erro ao carregar lista de estados de veículo')
            console.log(error)
          })
      },
      carregarEntregadoresPatio () {
        AtendentePatioService.list(10000, 1, '')
          .then(response => {
            this.entregadoresPatio = response.data.result
          })
          .catch(error => {
            alert('Erro ao carregar lista de atendentes de pátio')
            console.log(error)
          })
      },
      getListaPoliciais: debounce(function () {
        this.policiais = []
        this.loading = true
        const filtro = this.filtro.trim()
        if (filtro) {
          this.setVisibilityOptionsAutocomplete(true)
          this.carregarPoliciais(filtro)
        } else {
          // this.policialSelecionado = null
          this.loading = false
          this.setVisibilityOptionsAutocomplete(false)
        }
      }, 300),
      setVisibilityOptionsAutocomplete (status) {
        setTimeout(() => {
          this.showOptionsAutocomplete = status
        }, 100)
      }
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition" v-if="dataRequiredLoaded">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-warning lter b-b wrapper-md" v-if="isPreenchidoAutomaticamente">
              <div class="row">
                <div class="col-xs-12">
                  <h1 class="font-thin h5 text-black">
                    <strong>Atenção</strong><br>
                    Alguns campos foram preenchidos automaticamente com base nos dados do último agendamento realizado para esta GRV.
                    <br>
                    É recomendado conferir os dados antes de confirmar.
                  </h1>
                </div>
              </div>
            </div>
          </div>

          <div class="panel panel-default">
            <div class="clearfix">
              <div>
                <form @submit.prevent.stop="submit" class="bs-example form-horizontal form-grv">
                  <div class="wrapper">
                    <div class="panel-body">
                      <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
                        <div class="m-b-sm font-bold">Erro ao registrar a GRV, corrija e tente novamente</div>
                        <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
                      </div>
                      <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
                      <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null" class="alert alert-success">
                        <div class="font-bold">Atualizado com sucesso!</div>
                      </div>
                      <div class="col-sm-12 col-xs-12 m-b" v-if="data.id">
                        <h1 class="font-thin h3"></h1>
                      </div>

                      <div class="wrapper">
                        <div class="panel-body">
                          <hr>
                          <h4>Devolução</h4>

                          <div class="form-group">
                            <label for="dataEntregaDevolucao" class="col-sm-2 control-label">Data Entrega</label>
                            <div class="col-sm-10">
                              <input id="dataEntregaDevolucao" type="text" class="form-control" placeholder="dd/mm/yyyy hh:mm" v-mask="'##/##/#### ##:##'" v-model="data.dataEntregaDevolucao"/>
                            </div>
                          </div>

                          <div class="form-group">
                            <label for="tipoDevolucao" class="col-sm-2 control-label">Tipo de Devolução</label>
                            <div class="col-sm-10">
                              <select name="" id="tipoDevolucao" class="form-control" v-model="data.tipoDevolucao">
                                <option :value="null" disabled>Selecione</option>
                                <option :value="tipo.id" v-for="tipo in tiposDevolucao">{{tipo.nome}}</option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group">
                            <label for="nomeDevolucao" class="col-sm-2 control-label">Nome</label>
                            <div class="col-sm-10">
                              <input id="nomeDevolucao" type="text" class="form-control" v-model="data.nomeDevolucao"/>
                            </div>
                          </div>

                          <div class="form-group">
                            <label for="cpfDevolucao" class="col-sm-2 control-label">CPF</label>
                            <div class="col-sm-10">
                              <input id="cpfDevolucao" type="text" class="form-control" v-mask="'###.###.###-##'" v-model="data.cpfDevolucao"/>
                            </div>
                          </div>

                          <div class="form-group">
                            <label for="telefone1" class="col-sm-2 control-label">Telefone #1</label>
                            <div class="col-sm-10">
                              <input id="telefone1" type="text" class="form-control" v-model="data.telefoneDevolucao1" v-mask="'(##) #####-####'"/>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="telefone2" class="col-sm-2 control-label">Telefone #2</label>
                            <div class="col-sm-10">
                              <input id="telefone2" type="text" class="form-control" v-model="data.telefoneDevolucao2" v-mask="'(##) #####-####'"/>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="telefone3" class="col-sm-2 control-label">Telefone #3</label>
                            <div class="col-sm-10">
                              <input id="telefone3" type="text" class="form-control" v-model="data.telefoneDevolucao3" v-mask="'(##) #####-####'"/>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="telefone4" class="col-sm-2 control-label">Telefone #4</label>
                            <div class="col-sm-10">
                              <input id="telefone4" type="text" class="form-control" v-model="data.telefoneDevolucao4" v-mask="'(##) #####-####'"/>
                            </div>
                          </div>

                          <div class="form-group">
                            <label class="col-sm-2 control-label">Entregador Pátio</label>
                            <div class="col-sm-10">
                              <select class="form-control" v-model="data.entregadorPatio">
                                <option :value="null" disabled selected>Selecione</option>
                                <option :value="entregador.id" v-for="entregador in entregadoresPatio">{{entregador.nome}}</option>
                              </select>
                            </div>
                          </div>

                          <!--</div>
                        </div>

                        <div class="wrapper">
                          <div class="panel-body">-->

                          <hr>
                          <div class="col-sm-offset-2 col-sm-10">
                            <div class="row">
                              <div class="col-xs-12">
                                <label class="i-checks m-b-none">
                                  <input type="checkbox"
                                         tabindex="0"
                                         id="veiculoSegurado"
                                         aria-checked="false"
                                         aria-invalid="false" v-model="data.veiculoSegurado"><i></i>
                                </label>
                                <label for="veiculoSegurado">Veículo Segurado</label>
                              </div>
                            </div>
                          </div>

                          <div class="form-group" v-if="data.veiculoSegurado">
                            <label for="seguradora" class="col-sm-2 control-label">Seguradora</label>
                            <div class="col-sm-10">
                              <select id="seguradora" class="form-control" v-model="data.seguradora">
                                <option :value="null" disabled>Selecione</option>
                                <option :value="seguradora.id" v-for="seguradora in seguradoras" :key="seguradora.id">{{seguradora.nome}}</option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group" v-if="data.veiculoSegurado">
                            <label for="apoliceSinistro" class="col-sm-2 control-label">Apólice / Sinistro</label>
                            <div class="col-sm-10">
                              <input id="apoliceSinistro" type="text" class="form-control" v-model="data.apoliceSinistro"/>
                            </div>
                          </div>

                          <div class="form-group">
                            <label for="tipoGev" class="col-sm-2 control-label">Tipo GEV</label>
                            <div class="col-sm-10">
                              <select id="tipoGev" class="form-control" v-model="data.tipo" required>
                                <option :value="null" disabled selected>Selecione</option>
                                <option :value="tipo.id" v-for="tipo in tiposGrv">{{tipo.nome}}</option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group">
                            <label for="observacoesGev" class="col-sm-2 control-label">Observações</label>
                            <div class="col-sm-10">
                          <textarea id="observacoesGev" v-model="data.observacoesGev" rows="7" class="form-control"
                                    style="resize: none;"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="wrapper">
                        <div class="panel-body">
                          <hr>
                          <h4>Reintegração</h4>

                          <div class="form-group">
                            <label for="dataContatoReintegracao" class="col-sm-2 control-label">Data Contato</label>
                            <div class="col-sm-10">
                              <input id="dataContatoReintegracao" type="text" class="form-control" placeholder="dd/mm/yyyy hh:mm" v-mask="'##/##/#### ##:##'" v-model="data.dataContatoReintegracao"/>
                            </div>
                          </div>

                          <div class="col-sm-offset-2 col-sm-10">
                            <div class="row">
                              <div class="col-xs-12">
                                <label class="i-checks m-b-none">
                                  <input type="checkbox"
                                         tabindex="0"
                                         aria-checked="false"
                                         aria-invalid="false" v-model="data.transferirProcesso"><i></i>
                                </label>
                                <label>Transferir Processo</label>
                              </div>
                            </div>
                          </div>

                          <div class="form-group">
                            <label for="patioTransferencia" class="col-sm-2 control-label">Transferir para o Pátio</label>
                            <div class="col-sm-10">
                              <select id="patioTransferencia" class="form-control" v-model="data.patioTransferencia">
                                <option :value="null">Selecione</option>
                                <option :value="patio.id" v-for="patio in dataRequired.patios" :key="patio.id">
                                  {{patio.nome}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <!--<div class="form-group">
                            <label class="col-sm-2 control-label">Empresa Contratante</label>
                            <div class="col-sm-10">
                              <select name="" class="form-control" v-model="data.empresaContratante">
                                <option value="" disabled>Selecione</option>
                              </select>
                            </div>
                          </div>-->

                          <div class="form-group">
                            <label class="col-sm-2 control-label">Reintegradora</label>
                            <div class="col-sm-10">
                              <select name="" class="form-control" v-model="data.reintegradora" @change="carregarRepresentantes">
                                <option :value="null" disabled>Selecione</option>
                                <option :value="reintegradora.id" v-for="reintegradora in reintegradoras" :key="reintegradora.id">
                                  {{reintegradora.nome}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group">
                            <label class="col-sm-2 control-label">Representante</label>
                            <div class="col-sm-10">
                              <select name="" class="form-control" v-model="data.representanteReintegradora">
                                <option :value="null" disabled>Selecione</option>
                                <option :value="representante.id" v-for="representante in representantes" :key="representante.id">
                                  {{representante.nome}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group">
                            <label for="observacoesReintegracao" class="col-sm-2 control-label">Observações</label>
                            <div class="col-sm-10">
                          <textarea id="observacoesReintegracao" rows="7" class="form-control" v-model="data.observacoesReintegracao"
                                    style="resize: none;"></textarea>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div><!-- END Padding -->
                  </div>

                  <!---->
                  <div class="wrapper">
                    <div class="panel-body">
                      <hr>
                      <h4>Equipamentos / Acessórios</h4>

                      <div class="form-group b-b padder-v" v-for="equip in dataRequired.equipamentos" :key="equip.id">
                        <div class="col-sm-offset-2 col-sm-10">
                          <div class="row">
                            <div class="col-xs-4">
                              <label class="i-checks m-b-none">
                                <input v-model="equip.checked" @change="marcaEquipamento($event, equip)" type="checkbox"
                                       :id="equip.id"
                                       tabindex="0"
                                       aria-checked="false"
                                       aria-invalid="false"><i></i>
                              </label>
                              <label :for="equip.id">{{equip.nome}}</label>
                            </div>
                            <div class="col-xs-4 form-inline" v-show="equip.checked">
                              <label>Avaria: </label>
                              <select class="form-control" v-model="equip.avaria">
                                <option :value="null" disabled selected>Nenhum</option>
                                <option :value="avaria.id" v-for="avaria in avarias" :key="avaria.id">{{avaria.nome}}</option>
                              </select>
                            </div>
                            <div class="col-xs-4" v-show="false">
                              <btn-check-possui v-model="equip.possui" v-show="equip.checked"/>
                            </div>
                          </div>
                        </div>
                      </div><!---->
                    </div>
                  </div>

                  <div class="bg-light lter b-b wrapper-md" v-if="isGgv">
                    <div class="row">
                      <div class="col-sm-6 col-xs-12">
                        <h2 class="font-thin h3">
                          Parecer Final
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div class="wrapper-md m-b-lg" v-if="isGgv">
                    <div class="row">
                      <label class="col-sm-4 control-label">Em conformidade com a GRV</label>
                      <div class="col-sm-8">
                        <select v-model="ggv.conforme" class="form-control">
                          <option :value="true">Conforme</option>
                          <option :value="false">Não conforme</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="wrapper" v-if="!isGgv">
                    <div class="panel-body">
                      <div class="row">
                        <button class="btn btn-success btn-md m-l-xs btn-colsultaGrv" type="submit">Salvar</button>
                      </div>
                    </div>
                  </div>
                  <div class="wrapper" v-else>
                    <div class="panel-body">
                      <div class="row">
                        <button class="btn btn-success btn-block btn-lg">Confirmar GGV</button>
                        <div class="text-center">
                          * a confirmação inclui imeditamente este bem no pátio e transmite as informações para o DETRO
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  .form-grv label {
    cursor: pointer;
  }

  .btn-colsultaGrv {
    padding-top: 7px;
    padding-bottom: 7px;
  }

  /* Raphael */
  .autocomplete-input {
    position: relative;
  }
  .autocomplete-input input {
    width: 100%;
    height: 100%;
  }
  .autocomplete-input ul {
    position: absolute;
    border: #999 1px solid;
    list-style-type: none;
    width: 100%;
    max-height: 80px;
    overflow: auto;
    background-color: #fff;
    z-index: 99;
  }
  .autocomplete-input ul li {
    padding: 5px;
    cursor: pointer;
  }
  .autocomplete-input ul li:hover {
    background-color: #fff;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// Gev.vue?0c1426ea